<div class="available-funds-container">
  @for (fund of funds; track fund.name) {
    <div class="fund">
      <div class="fund-title">
        <span class="fund-name">{{ fund.name }}</span>
        <span class="fund-type">{{ fund.type === 'FixedIncome' ? 'درامد ثابت' : 'سهامی' }}</span>
      </div>
      <div class="fund-value">
        <span>{{ fund.efficiency | number }}</span>
        <span class="is-currency">ریال</span>
      </div>
    </div>
  }
</div>
